export default __webpack_public_path__ + "static/media/illustration-study-2-m@2x.a33db2cf.webp";